import { Alert, Button } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import ErrorsString from "../ErrorsString";
import config from "../config";
import { GetShareModel } from "../models/GetShareModel";
import { useParams } from "react-router-dom";
import { ShareResponse } from "../models/ResponseModels/ShareResponse";
import Spinner from "../components/Spinner";
import { saveAs } from "file-saver";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { logDownload } from "../Utilities";
import SectionAccordionDetails from "../components/SectionAccordionDetails";
import { sharedLandingDetailsSections } from "../configurations/sharedLandingDetailsSections";

export default function SharedLandingPage() {
  const { token } = useParams();
  const [spinnerVisibility, setSpinnerVisibility] = useState(false);
  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);
  const [details, setDetails] = useState<ShareResponse | null>(null);

  function setError(message: string) {
    setShowAlert(true);
    setAlertMessage(message);
    setSpinnerVisibility(false);
  }

  const getImageDetails = useCallback(() => {
    console.log("Starting API call GetShareModel...");
    (async () => {
      const response = await GetShareModel(token);
      //console.log("GetShareModel response: " + JSON.stringify(response));

      const responseData = response?.data;
      const statusCode = response?.status;

      if (responseData === undefined) {
        setError(ErrorsString.errorMessageGeneric);
        return;
      }

      if (statusCode !== 200) {
        setError(ErrorsString.errorMessageGeneric);
        return;
      } else {
        setDetails(responseData);
        setSpinnerVisibility(false);
      }
    })();
  }, [token]);

  useEffect(() => {
    getImageDetails();
  }, [getImageDetails]);

  function downloadOriginalImage() {
    if (details.essence) {
      const url =
        config.cloudfrontImgUrl + "" + details.essence + config.showImagesQuery;
      let imageFileName = "";
      if (details.title_image) {
        imageFileName = details.title_image;
      } else {
        const today = new Date();
        const formattedDate = today.toLocaleDateString();
        imageFileName = "image" + formattedDate;
      }

      const fileExtension = details.file_extension
        ? details.file_extension
        : "jpg";
      imageFileName = imageFileName + "." + fileExtension;

      saveAs(url, imageFileName);

      logDownload(details.uuid, null);
    }
  }

  return (
    <>
      <Spinner visibility={spinnerVisibility} />

      <ScrollToTopButton></ScrollToTopButton>

      {details ? (
        <div id="image-body">
          <div id="actions" className="mb-4 mr-4">
            <Button
              className="float-right "
              variant="contained"
              color="primary"
              onClick={() => downloadOriginalImage()}
            >
              Download
            </Button>
          </div>
          <div className="flex">
            <div id="image-preview" className="p-4 w-1/2 h-1/2">
              <img
                src={
                  details.proxy != null
                    ? config.cloudfrontImgUrl +
                      "" +
                      details.proxy +
                      config.showImagesQuery
                    : config.placeholderImageUrl
                }
                className="w-full h-full"
                alt={details.proxy}
              />
            </div>
            <div id="image-details" className=" p-4 w-1/2 mt-4">
              <div id="details" className=" mt-8">
                {sharedLandingDetailsSections.map((section) => (
                  <SectionAccordionDetails
                    key={section.id}
                    section={section}
                    details={details}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Alert
          severity="error"
          style={{
            display: showAlert ? "flex" : "none",
          }}
        >
          {alertMessage}
        </Alert>
      )}
    </>
  );
}
